// Material Dashboard 2 React components
import MDBox from "components/MDBox";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Header from "./header";
import { useAuth } from "context";
import { NavbarAlert } from "examples/Alert";

// Data
function OrderHistory() {
  const { miniSidenav } = useAuth();
  return (
    <>
      <DashboardNavbar />
      <NavbarAlert />
      <DashboardLayout>
        <MDBox
          sx={{
            mt: 10,
            "@media (max-width:767px)": {
              mt: 10,
            },
          }}
        >
          {miniSidenav && (
            <MDBox
              sx={{
                "@media (max-width:767px)": {
                  mb: 1,
                },
              }}
              className="text-lg text-black font-medium"
            >
              Order History
            </MDBox>
          )}
          <Header />
        </MDBox>
      </DashboardLayout>
    </>
  );
}

export default OrderHistory;
